export const statusVariants = {
    odoo_purchase_order: {
        status: {
            draft: {
                class: 'bg-light',
                label_key: 'purchase_orders.odoo_purchase_orders.states.draft',
            },
            'to approve': {
                class: 'bg-warning',
                label_key: 'purchase_orders.odoo_purchase_orders.states.to_approve',
            },
            purchase: {
                class: 'bg-success',
                label_key: 'purchase_orders.odoo_purchase_orders.states.purchase',
            },
            done: {
                class: 'bg-success-custom',
                label_key: 'purchase_orders.odoo_purchase_orders.states.done',
            },
            cancel: {
                class: 'bg-danger',
                label_key: 'purchase_orders.odoo_purchase_orders.states.cancel',
            }
        },
        invoice_status: {
            no: {
                class: 'bg-light',
                label_key: 'purchase_orders.odoo_purchase_orders.invoice_statuses.no',
            },
            'to invoice': {
                class: 'bg-warning',
                label_key: 'purchase_orders.odoo_purchase_orders.invoice_statuses.to_invoice',
            },
            invoiced: {
                class: 'bg-success',
                label_key: 'purchase_orders.odoo_purchase_orders.invoice_statuses.invoiced',
            }
        },
    },
    odoo_sale_order: {
        status: {
            draft: {
                class: 'bg-light',
                label_key: 'sale_notes.odoo_sale_orders.states.draft',
            },
            'sent': {
                class: 'bg-warning',
                label_key: 'sale_notes.odoo_sale_orders.states.to_approve',
            },
            sale: {
                class: 'bg-success',
                label_key: 'sale_notes.odoo_sale_orders.states.sale',
            },
            done: {
                class: 'bg-success-custom',
                label_key: 'sale_notes.odoo_sale_orders.states.done',
            },
            cancel: {
                class: 'bg-danger',
                label_key: 'sale_notes.odoo_sale_orders.states.cancel',
            }
        },
        invoice_status: {
            no: {
                class: 'bg-light',
                label_key: 'sale_notes.odoo_sale_orders.invoice_statuses.no',
            },
            'to invoice': {
                class: 'bg-warning',
                label_key: 'sale_notes.odoo_sale_orders.invoice_statuses.to_invoice',
            },
            invoiced: {
                class: 'bg-success',
                label_key: 'sale_notes.odoo_sale_orders.invoice_statuses.invoiced',
            }
        },
    },
    odoo_account_move: {
        status: {
            draft: {
                class: 'bg-light',
                label_key: 'odoo_account_payments.states.draft',
            },
            posted: {
                class: 'bg-primary',
                label_key: 'odoo_account_payments.states.posted',
            },
            cancel: {
                class: 'bg-danger',
                label_key: 'odoo_account_payments.states.cancel',
            }
        },
        payment_status: {
            not_paid: {
                class: 'bg-danger',
                label_key: 'odoo_account_payments.payment_states.no',
            },
            in_payment: {
                class: 'bg-warning',
                label_key: 'odoo_account_payments.payment_states.in_payment',
            },
            partial: {
                class: 'bg-primary',
                label_key: 'odoo_account_payments.payment_states.partial',
            },
            paid: {
                class: 'bg-success',
                label_key: 'odoo_account_payments.payment_states.paid',
            },
        },
    },
    user: {
        status: {
            active: {
                class: 'bg-success',
                label_key: 'active',
            },
            inactive: {
                class: 'bg-danger',
                label_key: 'inactive',
            }
        }
    },
    approval_template: {
        status: {
            active: {
                class: 'bg-success',
                label_key: 'active',
            },
            inactive: {
                class: 'bg-danger',
                label_key: 'inactive',
            }
        }
    },
    sales_plan: {
        status: {
            draft: {
                class: 'bg-light',
                label_key: 'sales_plans.statuses.draft',
            },
            in_review: {
                class: 'bg-warning',
                label_key: 'sales_plans.statuses.in_review',
            },
            published: {
                class: 'bg-primary',
                label_key: 'sales_plans.statuses.published',
            },
            rejected: {
                class: 'bg-danger',
                label_key: 'sales_plans.statuses.rejected',
            },
            approved: {
                class: 'bg-success',
                label_key: 'sales_plans.statuses.approved',
            },
            cancelled: {
                class: 'bg-black',
                label_key: 'sales_plans.statuses.cancelled',
            },
        },
        approval_status: {
            pending: {
                class: 'bg-warning',
                label_key: 'sales_plans.approval_statuses.pending',
            },
            current: {
                class: 'bg-warning',
                label_key: 'sales_plans.approval_statuses.pending',
            },
            approved: {
                class: 'bg-success',
                label_key: 'sales_plans.approval_statuses.approved',
            },
            rejected: {
                class: 'bg-danger',
                label_key: 'sales_plans.approval_statuses.rejected',
            },
            cancelled: {
                class: 'bg-black',
                label_key: 'sales_plans.approval_statuses.cancelled',
            },
        },
    },
    purchase_plan: {
        status: {
            draft: {
                class: 'bg-light',
                label_key: 'purchase_plans.statuses.draft',
            },
            in_review: {
                class: 'bg-warning',
                label_key: 'purchase_plans.statuses.in_review',
            },
            published: {
                class: 'bg-primary',
                label_key: 'purchase_plans.statuses.published',
            },
            rejected: {
                class: 'bg-danger',
                label_key: 'purchase_plans.statuses.rejected',
            },
            approved: {
                class: 'bg-success',
                label_key: 'purchase_plans.statuses.approved',
            },
            cancel: {
                class: 'bg-cancelled',
                label_key: 'purchase_plans.statuses.cancel',
            },
        },
        approval_status: {
            pending: {
                class: 'bg-warning',
                label_key: 'sales_plans.approval_statuses.pending',
            },
            current: {
                class: 'bg-warning',
                label_key: 'sales_plans.approval_statuses.pending',
            },
            approved: {
                class: 'bg-success',
                label_key: 'sales_plans.approval_statuses.approved',
            },
            rejected: {
                class: 'bg-danger',
                label_key: 'sales_plans.approval_statuses.rejected',
            },
            cancelled: {
                class: 'bg-cancelled',
                label_key: 'purchase_plans.approval_statuses.cancelled',
            },
        },
    },
    balancing_approval: {
        status: {
            not_submitted: {
                class: 'bg-light',
                label_key: 'balancing_approvals.statuses.not_submitted',
            },
            published: {
                class: 'bg-primary',
                label_key: 'balancing_approvals.statuses.published',
            },
            in_review: {
                class: 'bg-warning',
                label_key: 'balancing_approvals.statuses.in_review',
            },
            approved: {
                class: 'bg-success',
                label_key: 'balancing_approvals.statuses.approved',
            },
            rejected: {
                class: 'bg-danger',
                label_key: 'balancing_approvals.statuses.rejected',
            },
        },
        approval_status: {
            pending: {
                class: 'bg-warning',
                label_key: 'sales_plans.approval_statuses.pending',
            },
            current: {
                class: 'bg-warning',
                label_key: 'sales_plans.approval_statuses.pending',
            },
            approved: {
                class: 'bg-success',
                label_key: 'sales_plans.approval_statuses.approved',
            },
            rejected: {
                class: 'bg-danger',
                label_key: 'sales_plans.approval_statuses.rejected',
            },
        },
    },
}

export const getStatusVariants = (entity, type, value) => statusVariants[entity]?.[type]?.[value] || {
    class: 'bg-light',
    label_key: value,
}
